export default __webpack_public_path__ + "static/media/avalanche.d6d233e9.png";